import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
} from '@angular/core';
import { ApplyPipe } from '@interacta-shared/ui';
import { AISharedAttachmentChipComponent } from '@modules/ai-shared/components/ai-shared-attachment-chip/ai-shared-attachment-chip.component';
import { AISharedReferenceChipComponent } from '@modules/ai-shared/components/ai-shared-reference-chip/ai-shared-reference-chip.component';
import { getReferenceUnavailableLabel } from '@modules/ai-shared/helpers/ai-shared.utils';
import {
    AISharedGenericReference,
    AISharedMessageAttachment,
    AISharedUserMessage,
} from '@modules/ai-shared/models/ai-shared.model';
import { AISharedReferenceViewService } from '@modules/ai-shared/services/ai-shared-reference-view.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-ai-shared-user-message-balloon',
    templateUrl: './ai-shared-user-message-balloon.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        AISharedAttachmentChipComponent,
        AISharedReferenceChipComponent,
        ApplyPipe,
        TranslatePipe,
    ],
    styles: `
        :host {
            display: block;
        }
    `,
})
export class AISharedUserMessageBalloonComponent {
    private readonly referenceViewService = inject(
        AISharedReferenceViewService,
    );

    readonly message = input.required<AISharedUserMessage>();

    readonly getReferenceUnavailableLabel = getReferenceUnavailableLabel;

    openAttachment(attachment: AISharedMessageAttachment): void {
        this.referenceViewService.openMessageAttachment(attachment);
    }

    openReference(reference: AISharedGenericReference): void {
        this.referenceViewService.open(reference, 'list');
    }
}
